import PenEditButton from "components/shared/PenEditButton";
import ChoosePublisherSignerModal from "containers/ContractValidationEdit/ChoosePublisherSignerModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const EditPublisherSigner = () => {
    const [t] = useTranslation();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <ChoosePublisherSignerModal
                open={showModal}
                onClose={() => setShowModal(false)}
                modalTitle={t("ContractValidationEdit.EditPublisherSigner")}
                modalSubtitle={t("ContractValidationEdit.ChooseSignatorySubtitle")}
            />
            <PenEditButton
                onClick={() => setShowModal(true)}
                tooltipText={t("ContractValidationEdit.EditPublisherSigner")}
            />
        </>
    );
};

export default EditPublisherSigner;
